import { Component, OnInit, Input, Optional, Inject, HostListener } from '@angular/core';
import { INavigationService, PershingTranslationService } from '@pershing/pershing-core';
import { NxiNavigation } from '@pershing/nxi-common';
import { Location } from '@angular/common';
import { NxiMobileService } from '../services/nxi-mobile.service';
import { NavigationBaseComponent } from './navigation-base.component';

@Component({
    selector: 'mobile-navigation',
    templateUrl: 'mobile-nav.component.html'
})
export class MobileNavComponent extends NavigationBaseComponent implements OnInit {
    menuItems: any[];
    selectedPageId: string;
    navigation: NxiNavigation;
    showPostLogin: boolean = true;
    isOpen: boolean = false;
    @Input() isMobileTheme: boolean;
    @Input() isTabletTheme: boolean;
    @Input() showLanguageSwitch: boolean = false;
    parentpage: string;
    isLoggedIn: boolean = false;
    constructor(
        protected navigationService: INavigationService,
        protected location: Location,
        private mobileService: NxiMobileService,
        private translationService: PershingTranslationService,
        @Optional() @Inject('AppSettings') appSettings: any
    ) {
        super(navigationService, location, appSettings);
        this.translationService.addTranslationFolder('@pershing/nxi-navigation', 'node_modules/@pershing/nxi-navigation/lib');
        this.isLoggedIn = (appSettings && appSettings.isLoggedIn);
        this.linkUrl = appSettings.postLoginEquiptUrl;
    }

    handleChildNavigation(parentpage, childPage): void {
        this.navigation = new NxiNavigation();
        this.navigation.childPage = childPage;
        this.navigation.parentPage = parentpage;
        // For native mobile page , we need to do an href to make
        // the native app team capture the href event
        if (childPage.id === 'mobiledeposit') {
            location.href = '/nxi/mobile-deposit';
            return;
        }
        this.navigationService.handleNavigation(this.navigation);
        if (this.mobileService.isOpen) {
            this.mobileService.toggle();
        }
    }

    handleNavigation(parentpage): void {
        this.navigation = new NxiNavigation();
        this.navigation.parentPage = parentpage;
        this.navigationService.handleNavigation(this.navigation);
        if (this.mobileService.isOpen) {
            this.mobileService.toggle();
        }
    }
    handleNavigationLink(parentpage: any): void {
        if (parentpage.id === 'equipt') {
            window.location.href = parentpage.LinkUrl;
        } else {
            window.open(parentpage.LinkUrl);
        }
        return;
    }
    logout(): void {
        document.dispatchEvent(new CustomEvent('portal.LogoutEvent'));
    }

    ngOnInit() {
        super.ngOnInit();
        this.mobileService.change.subscribe(isOpen => {
            this.isOpen = isOpen;
            this.isOpen ? document.body.classList.add('openNav') : document.body.classList.remove('openNav');
        });
    }

    toggle(): void {
        this.mobileService.toggle();
    }

    processMenuItems() {
        this.menuItems.forEach(ele => {
            ele.flag = false;
        });
    }

    // Use cases - This is all about closing the sidenav if user clicks on some elements that is not handled or require additonal
    // handling e.g. the 'Menu' tab itself.
    // 1. User clicks on other than the 'Menu' tab within NXI-MOBILE and sidenav is OPEN, close the sidenav.
    // 2. User clicks on the 'Menu' tabs within NXI-MOBILE, just turn off the flag only. Toggle is already handled in init above.
    // 3. User clicks on anywhere besides side nav and tab list and side nav is open, close the side nav.
    @HostListener('document:click', ['$event']) onClick(event: Event) {
        let element = event.target as HTMLElement;
        while (element) {
            if (element.tagName.toUpperCase() === 'MOBILE-NAVIGATION' || element.tagName.toUpperCase() === 'NXI-MOBILE') {
                // For use case #1.
                if (this.mobileService.isOpen && !this.mobileService.isMobileMenuTabClickEvent) {
                    this.mobileService.toggle();
                    // For use case #2.
                } else if (this.mobileService.isMobileMenuTabClickEvent) {
                    this.mobileService.mobileMenuTabClickEvent(false);
                }
                return;
            } else if (element.tagName.toUpperCase() === 'MOD-INDICES') {
                event.preventDefault();
                return;
            } else if (element.tagName.toUpperCase() === 'LANGUAGE-SWITCH') {
                event.preventDefault();
                return;
            }
            element = element.parentElement;
        }
        // For use case #3.
        if (this.mobileService.isOpen) {
            this.mobileService.toggle();
        }
    }
}
